'use strict';

/** @type {import('.')} */
module.exports = Object;



//////////////////
// WEBPACK FOOTER
// ./~/react-router/~/es-object-atoms/index.js
// module id = 1845
// module chunks = 0